import React, { useState } from "react";

function Twitter(props) {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    if (props.isMobileView) setIsHovered(false);
    else setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <svg width="56" height="56" viewBox="0 0 56 56" fill={isHovered? "white" : "none"} xmlns="http://www.w3.org/2000/svg">
        <circle opacity={isHovered ? "1" : "0.4" } cx="28" cy="28" r="27.5" stroke="white" />
        <path d="M19.0474 18L26.5413 28.4819L19 37.0004H20.6973L27.3 29.541L32.6363 37.0008H38.4107L30.4946 25.9313L37.5142 18H35.817L29.7364 24.8688L24.823 18H19.0474ZM21.5435 19.3078H24.1969L35.9133 35.6926H33.2607L21.5435 19.3078Z" fill={isHovered ? "#1F2022" : "white"} />
      </svg>
    </div>
  );
}

export default Twitter;

